// extracted by mini-css-extract-plugin
export default {"container":"nearest-stores__container___17sn6","stores":"nearest-stores__stores___d2Qvs","map":"nearest-stores__map___OD8XH"};